/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BalanceEditModal from './BalanceEditModal';

function BalanceBox({ match, getMembers }) {
  const [isEditing, setIsEditing] = useState(false);
  const [onMouse, setOnMouse] = useState(false);
  const balance = match.balance / 60;
  const hours = Math.floor(balance / 60) < 10 ? `0${Math.floor(balance / 60)}` : Math.floor(balance / 60);
  const minutes = balance % 60 < 10 ? `0${balance % 60}` : balance % 60;

  return (
    <td
      style={{ position: 'relative', padding: '12px 8px', verticalAlign: 'middle' }}
      onMouseEnter={() => setOnMouse(true)}
      onMouseLeave={() => { setOnMouse(false); setIsEditing(false); }}
    >
      <span className="inline-flex items-center gap-2">
        <span className="text-sm text-ink-900 tabular-nums">{`${hours}:${Number(minutes).toFixed(2)}`}</span>
        {onMouse && (
          <button
            type="button"
            onClick={() => setIsEditing((v) => !v)}
            className={`inline-flex items-center box-border px-2 py-0.5 rounded-[6px] text-xs font-medium border bg-white transition ${isEditing ? 'text-[#CC4525] border-[#f3cfc6] hover:bg-[#fdf6f4]' : 'text-ink-900 border-rule hover:border-brand-500 hover:text-brand-700'}`}
            style={{ borderStyle: 'solid' }}
          >
            {isEditing ? 'Cancel' : 'Edit'}
          </button>
        )}
      </span>
      {isEditing && <BalanceEditModal match={match} getMembers={() => getMembers()} onClose={() => setIsEditing(false)} />}
    </td>
  );
}

BalanceBox.propTypes = {
  match: PropTypes.shape({
    id: PropTypes.number.isRequired,
    balance: PropTypes.number.isRequired,
    policyId: PropTypes.number.isRequired,
  }).isRequired,
  getMembers: PropTypes.func.isRequired,
};

export default BalanceBox;
